import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
} from "@mui/material";
import React from "react";
import { getIn } from "formik";

const RoomPicker = ({ formikProps, rooms, required, handleChange }) => {
  const {
    values,
    handleChange: formikHandleChange,
    handleBlur,
    touched,
    errors,
  } = formikProps;

  const key = "roomId";
  const touchedKey = getIn(touched, key);
  const errorKey = getIn(errors, key);
  const label = required ? "Room *" : "Room";

  return (
    <Box>
      <Box display={"flex"} gap={"20px"} marginTop={"20px"}>
        <FormControl
          sx={{ width: "350px" }}
          fullWidth
          error={Boolean(errorKey && touchedKey)}
        >
          <InputLabel id="room-label">{label}</InputLabel>
          <Select
            id={key}
            name={key}
            labelId="room-label"
            label={label}
            value={values[key] || ""}
            onBlur={handleBlur}
            onChange={async (e) => {
              await formikHandleChange(e);
              if (handleChange) {
                await handleChange(e);
              }
            }}
            required={required}
          >
            {!required && (
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
            )}
            {(rooms || []).map(({ id, name }) => {
              return (
                <MenuItem key={`"room-${id}`} value={id}>
                  {name}
                </MenuItem>
              );
            })}
          </Select>
          <FormHelperText>
            {touchedKey && errorKey ? errorKey : " "}
          </FormHelperText>
        </FormControl>
      </Box>
    </Box>
  );
};

export default RoomPicker;
